import React, { useEffect, useState } from "react";
import {
  EuiButton,
  EuiButtonEmpty,
  EuiForm,
  EuiFormRow,
  EuiModal,
  EuiModalBody,
  EuiModalFooter,
  EuiModalHeader,
  EuiModalHeaderTitle,
  useGeneratedHtmlId,
  EuiButtonIcon,
  EuiSpacer,
  EuiBadge,
  EuiCheckbox,
  EuiLink,
} from "@elastic/eui";
import OrganizationService from "../../services/organization-service";

const UserManageLicenses = ({ props, closeModalProp, item }) => {
  const [licenses, setLicenses] = useState([]);
  const [checkboxIdToSelectedMap, setCheckboxIdToSelectedMap] = useState({});
  const [changesMap, setChangesMap] = useState({}); // Nuevo estado para rastrear cambios

  const [response, setResponse] = useState("");

  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [responseColor, setResponseColor] = useState("success");

  const modalFormId = useGeneratedHtmlId({ prefix: "modalForm" });

  const handleCheckboxChange = (licenseId) => {
    const isSelected = !checkboxIdToSelectedMap[licenseId];
    const updatedMap = { ...checkboxIdToSelectedMap, [licenseId]: isSelected };
    setCheckboxIdToSelectedMap(updatedMap);

    setLicenses((currentLicenses) =>
      currentLicenses.map((license) => {
        if (license.skuId === licenseId) {
          return {
            ...license,
            consumedUnits: isSelected
              ? license.consumedUnits + 1
              : Math.max(0, license.consumedUnits - 1),
          };
        }
        return license;
      })
    );
    const initialSelected =
      licenses.find((license) => license.skuId === licenseId)?.inUse ?? false;
    if (isSelected !== initialSelected) {
      setChangesMap((prev) => ({ ...prev, [licenseId]: isSelected }));
    } else {
      setChangesMap((prev) => {
        const newChanges = { ...prev };
        delete newChanges[licenseId];
        return newChanges;
      });
    }
  };

  const closeModal = () => {
    setIsModalVisible(false);
    closeModalProp();
  };
  const showModal = () => setIsModalVisible(true);

  const assignLicenses = async (event) => {
    event.preventDefault();
    setLoading(true);
    console.log(changesMap);

    let addLicenses = [];
    let removeLicenses = [];

    Object.entries(changesMap).forEach(([skuId, isSelected]) => {
      if (isSelected) {
        addLicenses.push({ skuId: skuId });
      } else {
        removeLicenses.push(skuId);
      }
    });

    const data = {
      organizationId: props.data.company,
      email: item.mail,
      addLicenses,
      removeLicenses,
    };

    const token = sessionStorage.getItem("krakenT");

    OrganizationService.assignLicenses({ token, data })
      .then((response) => {
        const message =
          response.data.status === "success"
            ? "User updated succesfully"
            : "Unexpected response format";
        setResponseColor("success");
        setLoading(false);
        setResponse(message);
      })
      .catch((error) => {
        const errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : "Some error occurred";

        console.error(errorMessage);
        setResponseColor("danger");
        setLoading(false);
        setResponse(errorMessage);
      })
      .finally(() => {
        setLoading(false);
      });
    setChangesMap({});
  };

  useEffect(() => {
    if (isModalVisible) {
      setLoading(true);

      const token = sessionStorage.getItem("krakenT");
      const organizationId = props.data.company;
      const email = item.mail;

      OrganizationService.getLicensesByMsGraph({ token, organizationId, email })
        .then(({ data: { data: licensesResponse } }) => {
          setLoading(false);
          setLicenses(licensesResponse);
          const initialMap = licensesResponse.reduce(
            (acc, { skuId, inUse }) => {
              acc[skuId] = inUse;
              return acc;
            },
            {}
          );

          setCheckboxIdToSelectedMap(initialMap);
        })
        .catch((error) => {
          const errorMessage =
            error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : "Some error occurred";

          console.error(errorMessage);
          setResponseColor("danger");
          setLoading(false);
          setResponse(errorMessage);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [props, item.mail, isModalVisible]);

  let modal;

  if (isModalVisible) {
    modal = (
      <EuiModal
        onClose={closeModal}
        initialFocus="[name=popswitch]"
        onSubmit={assignLicenses}
      >
        <EuiModalHeader>
          <EuiModalHeaderTitle>Managing licenses</EuiModalHeaderTitle>
        </EuiModalHeader>

        <EuiModalBody>
          <EuiBadge>{item.mail}</EuiBadge>
          <EuiSpacer></EuiSpacer>
          <EuiLink
            href="https://learn.microsoft.com/en-us/entra/identity/users/licensing-service-plan-reference"
            target="_blank"
          >
            See Microsoft's current licensing details
          </EuiLink>{" "}
          <EuiSpacer size="m" />
          <EuiForm component="form" onSubmit={assignLicenses}>
            {licenses.map((license) => (
              <EuiFormRow
                key={license.skuId}
                label={`${license.skuPartNumber} (${license.consumedUnits}/${license.prepaidUnits} used)`}
              >
                <EuiCheckbox
                  id={license.skuId}
                  name={license.skuPartNumber}
                  checked={checkboxIdToSelectedMap[license.skuId] || false}
                  disabled={
                    license.consumedUnits >= license.prepaidUnits &&
                    !checkboxIdToSelectedMap[license.skuId]
                  }
                  onChange={() => handleCheckboxChange(license.skuId)}
                />
              </EuiFormRow>
            ))}
          </EuiForm>
          <EuiSpacer size="m" />
          {response !== "" && (
            <EuiBadge color={responseColor}>{response}</EuiBadge>
          )}
        </EuiModalBody>

        <EuiModalFooter>
          <EuiButtonEmpty onClick={closeModal}>Cancel</EuiButtonEmpty>

          <EuiButton
            onClick={assignLicenses}
            form={modalFormId}
            fill
            isLoading={loading}
          >
            Save
          </EuiButton>
        </EuiModalFooter>
      </EuiModal>
    );
  }

  return (
    <div>
      <EuiButtonIcon
        color="primary"
        size="xs"
        display="base"
        iconType="documentEdit"
        aria-label="Next"
        onClick={showModal}
      ></EuiButtonIcon>
      {modal}
    </div>
  );
};

export default UserManageLicenses;
